export const initialState = {
    images: [],
    isLoading: false,
    error: null,
    nextPage: 1,
    stats: {},
};
